import { Button, CloseButton, Dialog, Image } from "@chakra-ui/react";
import { useState } from "react";

const ButtonRecorridoVirtual = (url) => {
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    return (
        <>
            <Button
                rounded="full"
                color="#4F4F4F"
                fontSize="sm"
                fontWeight="400"
                borderWidth="1px"
                borderColor="#D9D9D9"
                bg="white"
                boxShadow="md"
                onClick={onOpen}
            >
                <Image
                    boxSize="20px"
                    objectFit="cover"
                    src="https://media.grupoguia.mx/assets/home-page/fichas/360-grados.webp"
                    alt="Recorrido virtual"
                    loading="lazy"
                    mr={2}
                />
                Recorrido virtual
            </Button>
            <Dialog.Root
                isCentered
                open={isOpen}
                onOpenChange={() => onClose()}
                placement="center"
                size="full"
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content bg="#f8f8f8">
                        <Dialog.Header />
                        <Dialog.CloseTrigger asChild>
                            <CloseButton />
                        </Dialog.CloseTrigger>
                        <Dialog.Body>
                            <iframe src={url.url} width="100%" height="500px"></iframe>
                        </Dialog.Body>
                        <Dialog.Footer />
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
        </>
    );
};

export default ButtonRecorridoVirtual;
